import { createContext } from 'react';

export const AritoFormContext = createContext<any>(null);
